/**
 * 将角度归一化到 [0, 2π) 范围。
 * @param angle 原始角度（弧度）。
 * @returns 归一化后的角度。
 */
export function normalizeAngle(angle: number): number {
    const twoPi = Math.PI * 2;
    let value = angle % twoPi;
    if (value < 0) {
        value += twoPi;
    }
    return value;
}
